import { max as _max, maxBy as _maxBy } from "lodash-es";
import { createSelector } from "reselect";
import { SYNC_STORE_KEYS } from "../syncConfig";

const getDeletedObjects = (state) => state.deletedObjects;
const syncSelectors = SYNC_STORE_KEYS.map((k) => (state) => state[k]);
const deletedAndSyncSelectors = [getDeletedObjects, ...syncSelectors];

// finds max syncedAt out of all objects
export const getLastSynced = createSelector(syncSelectors, (...lists) =>
  _max(
    lists.map((i) => {
      const obj = _maxBy(i, "syncedAt");
      return obj ? obj.syncedAt : null;
    })
  )
);

const checkSomeObjPending = (objs) => objs.some((i) => i.modified || i.pending);
const checkSomeObjectDeleted = (deletedObjects) => {
  for (const k in deletedObjects) {
    if (deletedObjects[k].length) {
      return true;
    }
  }
  return false;
};

export const getIsSomeObjectPending = createSelector(
  deletedAndSyncSelectors,
  (deletedObjects, ...lists) =>
    checkSomeObjectDeleted(deletedObjects) ||
    lists.some((i) => checkSomeObjPending(i))
);
